import PPTX from './pptx';

export default PPTX;
